// extracted by mini-css-extract-plugin
module.exports = {"cell":"styles_cell__1sYCE","cellSelected":"styles_cellSelected__26qX9","celltrue":"styles_celltrue__1ABY9","cellfalse":"styles_cellfalse__2oR-z"};